import Animation from './animation'

class BasicAnimation extends Animation {

  constructor (options) {
    super(options)
    this.ripple = options.seriesChanged // We want to ripple if a serie was added, removed, changed order, etc.
  }

  match (serie) {
    // This should run last and do a basic update if another animation didn't run
    return true
  }

  animate (serie, entering, selection, merged, exiting) {
    this._insertZeroHeight(entering, serie)
    merged.duration(this.timing.duration)
          .delay(this.timing.delay)
          .tween('decorations', this.tweeners.decorations)
          .tween('all', this.tweeners.all)
  }

}

export default BasicAnimation
